export default function () {
    return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-1 border-gray-600"></div>
        </div>
    )
}
